import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import Breadcrumbs from './Breadcrumbs';
import Tooltip from '../../components/Tooltip';
import AddToList from '../../components/AddToList';
import NotificationAlertButton from '../../components/NotificationAlertButton';
import { MARKET_LIST_TYPE } from '../../components/AddToList/listTypeConfig';

import { isUnified } from '../../utils/helpers';
import { getGlobalSettings } from '../../utils/global_settings';

const rootNode = document.getElementById('breadcrumbs-general-root');

const permissions = {
  ...getGlobalSettings().permissions,
  ...JSON.parse(rootNode.dataset.permissions || '{}'),
};

const { currentUser } = getGlobalSettings();

const getNotification = (notification, store) => {
  if (notification === null) return null;

  if (isUnified(store)) {
    return (notification.itunes_connect && notification.google_play)
      ? notification.itunes_connect
      : null;
  }

  return notification[store];
};

class GeneralBreadcrumbs extends Component {
  constructor(props) {
    super(props);
    this.breadcrumbs = JSON.parse(rootNode.dataset.breadcrumbs);
    this.entitiesInfo = JSON.parse(rootNode.dataset.entitiesInfo || '[]');
    this.notification = JSON.parse(rootNode.dataset.notification || '{}');
    this.allowNotifications = rootNode.dataset.allowNotifications === 'true';
    this.metaData = JSON.parse(rootNode.dataset.metaData || '{}');

    this.hasEntitiesInfo = this.entitiesInfo.length > 0;

    this.state = {
      disabledAddTooltip: false,
    };
  }

  handleAddToListClick = () => this.setState({ disabledAddTooltip: true });

  handleModalClose = () => setTimeout(() => this.setState({ disabledAddTooltip: false }), 500);

  render() {
    const { disabledAddTooltip } = this.state;
    const { company, publisher, app } = this.breadcrumbs;

    return (
      <div className="flex-grow flex-column">
        <div className="flex-grow d-flex flex-column flex-md-row align-items-md-center justify-content-md-between app-header-section">
          <Breadcrumbs
            company={company}
            publisher={publisher}
            app={app}
          />
          <div className="flex-no-shrink d-flex flex-wrap flex-row align-items-center breadcrumbs-header-right-buttons">
            {this.hasEntitiesInfo && (
              <Tooltip
                id="add-to-list-tooltip"
                content={
                  permissions.allowMyMarkets
                    ? 'Add this entity to an existing market, or create a new one to start comparing'
                    : 'Upgrade to enable Markets functionality.'
                }
                placement="bottomRight"
                overlayStyle={disabledAddTooltip ? { display: 'none' } : {}}
              >
                <div>
                  <AddToList
                    disabled={!permissions.allowMyMarkets}
                    markets={this.markets}
                    entities={this.entitiesInfo}
                    listType={MARKET_LIST_TYPE}
                    defaultSelectedStore={this.metaData.store}
                    clickCallback={this.handleAddToListClick}
                    clickCloseCallback={this.handleModalClose}
                    customerId={currentUser.customerId}
                    currentUserId={currentUser.id}
                    ignoreCustomEvents
                  />
                </div>
              </Tooltip>
            )}
            {this.allowNotifications && (
              <div className="flex-no-shrink d-flex flex-wrap flex-row align-items-center">
                <div className="m-l-auto hidden-sm-down" />
                <NotificationAlertButton
                  notification={getNotification(this.notification, this.metaData.store)}
                  metaData={this.metaData}
                  allowNotifications={this.allowNotifications}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<GeneralBreadcrumbs />);
});
